import { Fragment } from "react";
import "./index.css";
function IosPageParis() {
  window.location.href = 'https://milocal-txd.web.app/ios-paris';
  return (
    <div className="content-page">
      <div className="ios-page">
        <div className="content">
          <img
            className="mb-2"
            src="assets/img/paris/android/logo.svg"
            alt=""
          />
          <img src="assets/img/paris/android/txt.svg" alt="" />
          <a
            className="btndownload"
            href="itms-services://?action=download-manifest&url=https://milocalapp.firebaseapp.com/assets/ios-paris/manifest.plist">
            <img src="assets/img/paris/android/3.svg" alt="" />
          </a>
          <img className="mb-2 card" src="assets/img/ios-sm/3.png" alt="" />
          <img className="mb-2 card" src="assets/img/ios-sm/4.png" alt="" />
          <img className="mb-2 card" src="assets/img/ios-sm/paso3-1.png" alt="" />
          <img className="mb-2" src="assets/img/paris/android/4.svg" alt="" />
        </div>
      </div>
      <img
        className="footer"
        src="assets/img/paris/android/footer.svg"
        alt=""
      />
    </div>
  );
}
export default IosPageParis;
